export async function prepareBugReportVideo(blob) {
  if (!blob.type.includes('webm')) return blob;

  const {
    Input,
    BlobSource,
    WEBM,
    Output,
    WebMOutputFormat,
    BufferTarget,
    Conversion,
  } = await import('mediabunny');
  const input = new Input({ source: new BlobSource(blob), formats: [WEBM] });
  try {
    const output = new Output({
      format: new WebMOutputFormat(),
      target: new BufferTarget(),
    });
    const conversion = await Conversion.init({
      input,
      output,
      copy: { mode: 'forced' },
    });
    if (!conversion.isValid) throw new Error('Invalid recording');
    await conversion.execute();
    return new Blob([output.target.buffer], { type: blob.type });
  } finally {
    input.dispose();
  }
}
